import React from 'react';

import { HighlightedName } from '../highlighted-name';

import {
  ListItem,
  ListItemButton,
  Labels,
  NameLabel,
  SectionLabel,
  ShopLogo,
} from './styles';

import { useAppContext } from 'src/components/app-context';

import { BaseItemProps } from './types';

type Props = BaseItemProps;

export const ShopItem = (props: Props) => {
  const { id, text, selected, order, onClick, query } = props;
  const { t } = useAppContext();

  const logoUrl = `https://cdn.pji.nu/g/ftg_logos/store_${id}.png`;

  return (
    <ListItem data-test="ShopItem" $selected={selected} order={order}>
      <ListItemButton onClick={onClick}>
        <Labels>
          <NameLabel>
            <HighlightedName query={query}>{text}</HighlightedName>
          </NameLabel>
          <SectionLabel>{t('search', 'suggest.store')}</SectionLabel>
        </Labels>

        <ShopLogo height={24} alt={text} src={logoUrl} />
      </ListItemButton>
    </ListItem>
  );
};
